<template>
  <a-card :bordered="false" title="商品数据" :headStyle="{fontSize:'18px'}">
    <div><span class="side">实时商品数据 </span> 更新时间: {{ now }}</div>
    <a-row class="row-style">
      <a-col :span="5">
        <div class="head-info"><span>商品访客数</span>
          <p>{{ todayData.productVisitorNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>商品浏览量</span>
          <p>{{ todayData.productViewNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>商品支付件/份数</span>
          <p>{{ todayData.productPaymentNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>被访问商品总数</span>
          <p>{{ todayData.totalProductsVisitedNumber }}</p></div>
      </a-col>
      <a-col :span="4">
        <div class="head-info"><span>商品收藏总数</span>
          <p>{{ todayData.totalProductCollectionNumber }}</p></div>
      </a-col>
    </a-row>
    <div>
      <span class="side">商品总览数据</span>
      <span class="right-title">
      <a-button :class="{ isActive1:isChange1 === 1}" style="border:0;" @click="getDataDays(1)">昨日</a-button>
      <a-button :class="{ isActive1:isChange1 === 7}" style="border:0;" @click="getDataDays(7)">近7天</a-button>
      <a-button :class="{ isActive1:isChange1 === 30}" style="border:0;" @click="getDataDays(30)">近30天</a-button>
      <span>
        <a-range-picker
          :disabledDate="disabledDate"
          :placeholder="['开始时间', '结束时间']"
          format="YYYY-MM-DD"
          :value="value"
          style="margin-right:12px;"
          :mode="mode"
          @calendarChange="handlePanelChange"
          @change="handleChange"
          @openChange="openChange"
        />
      </span>
    </span>
    </div>
    <a-row class="row-style">
      <a-col :span="5">
        <div class="head-info"><span>商品访客数</span>
          <p>{{ productData.productVisitorNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>商品浏览量</span>
          <p>{{ productData.productViewNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>商品支付件/份数</span>
          <p>{{ productData.productPaymentNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>被访问商品总数</span>
          <p>{{ productData.totalProductsVisitedNumber }}</p></div>
      </a-col>
      <a-col :span="4">
        <div class="head-info"><span>商品收藏总数</span>
          <p>{{ productData.totalProductCollectionNumber }}</p></div>
      </a-col>
    </a-row>
    <a-row>
      <div class="line-title">{{ titleHeader }}商品访客数</div>
      <div id="v-container" v-if='showChart'>
        <v-chart :forceFit="true" :height="500" :data="lineData" :padding="padding">
          <v-legend :position="position"/>
          <v-tooltip crosshairs="y"></v-tooltip>
          <v-axis></v-axis>
          <v-line position="date*value" color="type"></v-line>
        </v-chart>
      </div>
    </a-row>
    <div>
      <span class="side">商品排行榜</span>
      <span class="right-title">
      <a-button :class="{ isActive2:isChange2 === 1}" style="border:0;" @click="getDays(1)">昨日</a-button>
      <a-button :class="{ isActive2:isChange2 === 7}" style="border:0;" @click="getDays(7)">近7天</a-button>
      <a-button :class="{ isActive2:isChange2 === 30}" style="border:0;" @click="getDays(30)">近30天</a-button>
      <span>
        <a-range-picker
          :disabledDate="disabledDateTime"
          :placeholder="['开始时间', '结束时间']"
          format="YYYY-MM-DD"
          :value="valueTime"
          style="margin-right:12px;"
          :mode="modeTime"
          @calendarChange="handlePanelChangeTime"
          @change="handleChangeTime"
          @openChange="openChangeTime"
        />
      </span>
    </span>
    </div>
    <a-row class="ranking-list">
      <a-col :span="8">
        <rank-list class="ranking-list-item" title="访客榜" :list="visitorRankList"/>
      </a-col>
      <a-col :span="8">
        <rank-list title="支付榜" :list="payRankList"/>
      </a-col>
      <a-col :span="8">
        <rank-list title="销量榜" :list="salesRankList"/>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { RankList } from '@/components'
import moment from 'moment'

export default {
  name: 'ProductData',
  components: {
    RankList
  },
  data() {
    return {
      titleHeader: '昨日',
      isChange1: 1,
      isChange2: 1,
      now: '',
      payRankList: [],
      salesRankList: [],
      visitorRankList: [],
      todayData: {
        productVisitorNumber: 0,
        productViewNumber: 0,
        productPaymentNumber: 0,
        totalProductsVisitedNumber: 0,
        totalProductCollectionNumber: 0
      },
      productData: {
        productVisitorNumber: 0,
        productViewNumber: 0,
        productPaymentNumber: 0,
        totalProductsVisitedNumber: 0,
        totalProductCollectionNumber: 0
      },
      lineData: [],
      endTime: '',
      startTime: '',
      todayTime: '',
      yesterdayTime: '',
      start_at: '',
      end_at: '',
      position: 'top-right',
      showChart: false,
      padding: [40, 20, 80, 50],
      mode: ['date', 'date'],
      value: [],
      startValue: '',
      startTimeValue: '',
      modeTime: ['date', 'date'],
      valueTime: []
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getDataDays(1)
      this.getDays(1)
      this.today()
      this.showChart = true
    })
  },
  methods: {
    moment,
    handleChange(value) {
      this.value = value
    },
    handlePanelChange(value) {
      this.startValue = value[0]._d
      if (value[0] && value[1]) {
        this.start_at = moment(value[0]._d).format('YYYY-MM-DD')
        this.end_at = moment(value[1] ? value[1]._d : null).format('YYYY-MM-DD')
        this.getProductStatisticsData()
        this.isChange1 = -1
        this.titleHeader = ''
        this.getLogUtils().logWithTag(this.start_at) //2020-01-01
        this.getLogUtils().logWithTag(this.end_at)
      }
    },
    //上方日期选择框禁选31天范围
    disabledDate(current) {
      let days = moment().endOf('day').valueOf()
      if (current.valueOf() > days - 3600000 * 24) {
        return true
      }
      return current._d.getTime() > new Date(this.startValue).getTime() + 8.64e7 * 31 || current._d.getTime() < new Date(this.startValue).getTime() - 8.64e7 * 31
    },
    //上方日期选择框弹出框关闭回调
    openChange(open) {
      if (!open) {
        this.startValue = ''
      }
    },
    handleChangeTime(value) {
      this.valueTime = value
    },
    handlePanelChangeTime(value) {
      this.startTimeValue = value[0]._d
      if (value[0] && value[1]) {
        this.startTime = moment(value[0]._d).format('YYYY-MM-DD')
        this.endTime = moment(value[1] ? value[1]._d : null).format('YYYY-MM-DD')
        this.getVisitorRankList()
        this.getPayRankList()
        this.getSalesRankList()
        this.isChange2 = -1
        this.getLogUtils().logWithTag(this.startTimet) //2020-01-01
        this.getLogUtils().logWithTag(this.endTime)
      }
    },
    //下方日期选择框禁选31天范围
    disabledDateTime(current) {
      let days = moment().endOf('day').valueOf()
      if (current.valueOf() > days - 3600000 * 24) {
        return true
      }
      return current._d.getTime() > new Date(this.startTimeValue).getTime() + 8.64e7 * 31 || current._d.getTime() < new Date(this.startTimeValue).getTime() - 8.64e7 * 31
    },
    //下方日期选择框弹出关闭回调
    openChangeTime(open) {
      if (!open) {
        this.startTimeValue = ''
      }
    },
    //获取今天日期
    today() {
      var now = moment().subtract('days', 0).format('YYYY-MM-DD HH:mm:ss ')
      var today = moment().subtract('days', 0).format('YYYY-MM-DD')
      this.todayTime = today
      this.now = now
      this.getProductRealTime()
    },
    //上方昨日、近7天、近30天开始结束日期
    getDataDays(value) {
      var endTime = moment(new Date().getTime() - 3600 * 24 * 1000).format('YYYY-MM-DD')
      var startTime = moment().subtract('days', value).format('YYYY-MM-DD')
      this.start_at = startTime
      this.end_at = endTime
      this.value = null
      if (value == 30) {
        this.titleHeader = '近30天'
        this.isChange1 = value
      } else if (value == 7) {
        this.titleHeader = '近七天'
        this.isChange1 = value
      } else {
        this.titleHeader = '昨日'
        this.isChange1 = value
      }
      this.getProductStatisticsData()
    },
    //下方昨日、近7天、近30天开始结束日期
    getDays(value) {
      var endTime = moment(new Date().getTime() - 3600 * 24 * 1000).format('YYYY-MM-DD')
      var startTime = moment().subtract('days', value).format('YYYY-MM-DD')
      this.startTime = startTime
      this.endTime = endTime
      this.valueTime = null
      // if (value !== 1){
      //   this.isChange2 = 2
      // }
      this.isChange2 = value
      this.getVisitorRankList()
      this.getPayRankList()
      this.getSalesRankList()
    },
    //获取商品实时数据
    getProductRealTime() {
      this.getHttpServices().getProService().post('api/v2/productStatistics/getProductStatisticsRealTime', {
        specificDay: this.todayTime
      }).then(res => {
        this.todayData = res
        this.getLogUtils().logWithTag('商品实时数据', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取商品总览数据
    getProductStatisticsData() {
      this.getHttpServices().getProService().post('api/v2/productStatistics/getProductStatisticsData', {
        endDay: this.end_at,
        startDay: this.start_at
      }).then(res => {
        this.productData = res
        this.lineData = res.itemList

        this.getLogUtils().logWithTag('商品总览数据', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取访客排行榜
    getVisitorRankList() {
      this.getHttpServices().getProService().post('api/v2/productStatistics/getProductVisitorRank', {
        limit: 10,
        endDay: this.endTime,
        startDay: this.startTime
      }).then(res => {
        this.visitorRankList = res
        this.getLogUtils().logWithTag('访客排行榜', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取支付排行榜
    getPayRankList() {
      this.getHttpServices().getProService().post('api/v2/productStatistics/getProductPayRank', {
        pageSize: 10,
        endTime: this.endTime,
        startTime: this.startTime
      }).then(res => {
        this.payRankList = res
        this.getLogUtils().logWithTag('支付排行榜', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取销售排行榜
    getSalesRankList() {
      this.getHttpServices().getProService().post('api/v2/productStatistics/getProductOrderCountRank', {
        pageSize: 10,
        endTime: this.endTime,
        startTime: this.startTime
      }).then(res => {
        this.salesRankList = res
        this.getLogUtils().logWithTag('销售排行榜', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style lang="less">
.isActive1 {
  color: #40a9ff;
}

.isActive2 {
  color: #40a9ff;
}

.side {
  padding-left: 10px;
  line-height: 18px;
  font-size: 16px;
  border-left: 1px solid cornflowerblue;
}

.row-style {
  padding: 20px;
  border-radius: 3px;
  margin: 15px 0;
  border: 1px solid #d5d5d5;
}

.line-title {
  margin: 20px 0 20px 10px;
  font-size: 14px;;
}

.right-title {
  position: absolute;
  right: 20px;
}

.ranking-list {
  min-height: 410px;
  margin-top: 30px;;

  .ranking-list-item {
    margin: 0;
    padding: 0;
  }
}

.head-info {
  position: relative;
  text-align: left;
  padding: 0 32px 0 0;
  min-width: 125px;

  span {
    color: rgba(0, 0, 0, .45);
    display: inline-block;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 4px;
  }

  p {
    color: rgba(0, 0, 0, .85);
    font-size: 24px;
    line-height: 32px;
    margin: 0;
  }
}
</style>
